/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-body.bank-account-picker[_ngcontent-%COMP%]{height:100%;display:flex;align-items:center}.insufficient-funds[_ngcontent-%COMP%]{color:#f90;font-weight:700;font-size:14px}"];
export { styles as styles };
